module.exports = __webpack_public_path__ + "static/media/contact-list.c8a75252.png";